module.exports = __webpack_public_path__ + "img/saum_beige_ral1014.0d407b9b.jpg";